import { useMutation } from '@tanstack/react-query';

import { TasksApi } from 'api/TasksApi';
import { FI_TASK_KEY } from 'hooks/keys';
import { useUser } from 'hooks/queries/useUser';
import { getNotificationStore } from 'stores/NotificationStore';
import { useFiTaskCache } from '../useFiTaskCache';

export function useDeleteFiTask() {
  const { user, userBankId } = useUser();
  const { invalidateTaskDetails, removeTask } = useFiTaskCache();
  const tasksApi = new TasksApi();

  const { mutateAsync: deleteFiTask, isPending: isDeleteFiTaskPending } = useMutation({
    mutationKey: [FI_TASK_KEY],
    mutationFn: (taskId: string) => tasksApi.deleteTask(userBankId, taskId),
    onSuccess: (_, taskId) => {
      removeTask(taskId);
      invalidateTaskDetails([taskId]);
      getNotificationStore().getAllUserNotifications(userBankId, user?.id ?? '');
    },
    meta: {
      snackbarErrorMessage:
        'There was a problem deleting the task. Please try again or contact our help desk!'
    }
  });

  return { deleteFiTask, isDeleteFiTaskPending };
}
